import {useId} from "react";

interface CreateAnotherCheckboxProps {
	checked: boolean;
	onCheckedChange: (checked: boolean) => void;
}

/**
 * The "Create another" checkbox for a dialog footer — it reports the tick state, the owning dialog decides what
 * "another" means. Mirrors the legacy {@code RecordModal.addCheckbox} in {@code bootstrapModal}.
 */
export function CreateAnotherCheckbox({checked, onCheckedChange}: CreateAnotherCheckboxProps) {
	const checkboxId = useId();
	return (
		<label
			htmlFor={checkboxId}
			className="input-group checkbox-inline pr-15 display-inline-block"
			title={messages["dialog.another.checkbox.tooltip"]}
		>
			<input
				id={checkboxId}
				type="checkbox"
				checked={checked}
				onChange={e => onCheckedChange(e.target.checked)}
			/>
			{messages["dialog.another.checkbox"]}
		</label>
	);
}
